<template>
  <div>
    <icon-view
      class="mr-2 mt-3 rounded-circle icon-view-color-text"
      icon="fas fa-map-marker-alt mb-1"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      title="Información de Dirección(es)"
      :gradient="true"
    />
    <div v-if="!readOnly">
      <div class="mt-4">
        <span class="data-title d-block mb-2 font-1">Tipo:</span>
        <strong class="font-16">Física</strong>
      </div>
      <validation-observer ref="physicalForm" class="col-12">
        <div class="row mt-2">
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Dirección (Línea 1):
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomPhysicalAddressLine1"
              rules="required"
            >
              <custom-input
                id="customPhysicalAddressLine1"
                v-model="model.physical.addressLine1"
                maxlength="256"
                :error="errors[0]"
                custom-error-msg="La dirección (línea) 1 es requerida."
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Dirección (Línea 2):
            </span>
            <custom-input
              id="customPhysicalAddressLine2"
              v-model="model.physical.addressLine2"
              maxlength="256"
              :disabled="readOnly"
            />
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Municipio:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomPhysicalMunicipality"
              rules="required"
            >
              <custom-drop-down
                id="customPhysicalMunicipality"
                v-model="model.physical.municipality"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="El municipio es requerido."
                :error="errors[0]"
                :options="municipalities"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <span class="data-title d-block mb-2">
              Código Postal:
            </span>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                min: 'El código postal no es válido.',
                max: 'El código postal no es válido.',
                required: 'El código postal es requerido.'
              }"
              name="validationCustomPhysicalZipcode"
              rules="required|min:5|max:10"
            >
              <custom-input
                id="customPhysicalEmail"
                v-model="model.physical.zipcode"
                mask-type="ZipcodeExt"
                placeholder="xxxxx-xxxx"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
        </div>
      </validation-observer>
      <div>
        <hr class="divider-horizontal" />
      </div>
      <div class="mt-4">
        <span class="data-title d-block mb-2 font-1">Tipo:</span>
        <strong class="font-16">Postal</strong>
      </div>
      <validation-observer ref="postalForm" class="col-12">
        <div class="row mt-2">
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Dirección (Línea 1):
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomPostalAddressLine1"
              rules="required"
            >
              <input
                v-if="disabledPostal"
                id="customPostalAddressLine1Disabled"
                type="text"
                class="form-control"
                disabled
                :value="model.postal.addressLine1"
              />
              <custom-input
                v-else
                id="customPostalAddressLine1"
                v-model="model.postal.addressLine1"
                maxlength="256"
                :error="errors[0]"
                custom-error-msg="La dirección línea 1 es requerida."
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Dirección (Línea 2):
            </span>
            <input
              v-if="disabledPostal"
              id="customPostalAddressLine2Disabled"
              type="text"
              class="form-control"
              disabled
              :value="model.postal.addressLine2"
            />
            <custom-input
              v-else
              id="customPostalAddressLine2"
              v-model="model.postal.addressLine2"
              maxlength="256"
            />
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">
              Municipio:
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomPostalMunicipality"
              rules="required"
            >
              <custom-drop-down
                id="customPostalMunicipality"
                v-model="model.postal.municipality"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="El municipio es requerido."
                :error="errors[0]"
                :options="municipalities"
                :disabled="disabledPostal"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <span class="data-title d-block mb-2">
              Código Postal:
            </span>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                min: 'El código postal no es válido.',
                max: 'El código postal no es válido.',
                required: 'El código postal es requerido.'
              }"
              name="validationCustomPostalZipcode"
              rules="required|min:5|max:10"
            >
              <input
                v-if="disabledPostal"
                id="customPostalEmailDisabled"
                type="text"
                class="form-control"
                disabled
                :value="model.postal.zipcode"
              />
              <custom-input
                v-else
                id="customPostalEmail"
                v-model="model.postal.zipcode"
                mask-type="ZipcodeExt"
                placeholder="xxxxx-xxxx"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <check-box
              id="same-physical-check"
              v-model="hasPostalSamePropsThanPhysical"
              class="font-weight-bold text-md-nowrap mt-5"
              text="La misma dirección que la física"
            />
          </div>
        </div>
      </validation-observer>
    </div>
    <div v-else class="py-4">
      <callout :has-toggle="false" class="mt-3" :controlled="true">
        <div class="row mt-3 mb-3">
          <div class="col-md-1 col-sm-12">
            <div class="phone-icon mt-2">
              <i class="fas fa-map-marker-alt"></i>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <span class="data-title d-block mb-2">Tipo de Dirección:</span>
            <strong>Física</strong>
          </div>
          <div class="col-md-7 col-sm-12">
            <span class="data-title d-block mb-2">
              Dirección Física:
            </span>
            {{ formatAddress(model.physical) }}
          </div>
          <div class="col-md-1 col-sm-12 d-flex justify-content-end">
            <ActionButton
              v-if="this.readOnly && hasEditPermission"
              class="btn-action-size mr-3 d-flex justify-content-center align-items-center"
              variant="success"              
              i="fas fa-pen"
              @click="showPhysicalEditAddress()"
            />    
          </div>
        </div>
      </callout>
      <address-information
        v-if="modelToEdit.physical.isEdit"
        title="Editar Dirección Fisica"
        ref="physicalAddressRef"
        v-model="modelToEdit.physical"      
        :municipalities="municipalities"  
        @cancel="cancelPhysicalAddress"
        @save="saveAddressInformation($event, modelToEdit.physical)"
        @invalid-address="onInvalidAddress('Fisica')"     
        @input="onChangePhysicalAddress"   
      />
      <callout :has-toggle="false" class="mt-3" :controlled="true">
        <div class="row mt-3 mb-3">
          <div class="col-md-1 col-sm-12">
            <div class="phone-icon mt-2">
              <i class="fas fa-map-marker-alt"></i>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <span class="data-title d-block mb-2">Tipo de Dirección:</span>
            <strong>Postal</strong>
          </div>
          <div class="col-md-7 col-sm-12">
            <span class="data-title d-block mb-2">
              Dirección Postal:
            </span>
            {{ formatAddress(model.postal) }}
          </div>
          <div class="col-md-1 col-sm-12 d-flex justify-content-end">
            <ActionButton
              v-if="this.readOnly && hasEditPermission"
              variant="success"    
              class="btn-action-size mr-3 d-flex justify-content-center align-items-center "          
              i="fas fa-pen"
              @click="showPostalEditAddress()"
            />                         
          </div>
        </div>
      </callout>
      <address-information
        v-if="modelToEdit.postal.isEdit"
        title="Editar Dirección Postal"
        ref="physicalAddressRef"
        v-model="modelToEdit.postal"
        :municipalities="municipalities"
        @cancel="cancelPostalAddress"
        @save="saveAddressInformation($event, modelToEdit.postal)"
        @invalid-address="onInvalidAddress('Postal')"    
        @check-same-address-than-physical="copyFisicalAddress($event)"
        is-postal    
      />
    </div>
  </div>
</template>

<script>
// Components
import Callout from "custom-callout";
import CustomDropDown from "custom-drop-down";
import CustomInput from "CustomInput";
import CheckBox from "CheckBox";
import IconView from "icon-view";
import ActionButton from "ActionButton";
import AddressInformation from "@/views/student/referralPartCToPartB/components/AddressInformation";
import StudentServices from "@/services/student";
import addressType from "@/utils/constants/addressType.js"

// Utils
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";

export default {
  name: "registrationAddressInformation",
  mixins: [alertMixin],
  components: {
    Callout,
    CustomDropDown,
    CustomInput,
    CheckBox,
    IconView,
    ActionButton,
    AddressInformation  
  },
  computed: {
    disabledPostal() {
      return this.sameAsPhysical || this.readOnly;
    },
    hasPostalSamePropsThanPhysical: {
      get() {
        if (
          this.sameAsPhysical === undefined &&
          this.model?.physical?.addressLine1
        ) {
          this.sameAsPhysical = this.hasSameProps(
            this.model.physical,
            this.model.postal
          );
        }

        return this.sameAsPhysical;
      },
      set(checkValue) {
        this.sameAsPhysical = checkValue;
        this.setValuesFromPhysical(checkValue);
      }
    },
    hasEditPermission(){              
      return this.userHasPermissions('student.partcpartbreferral.onlineregistration.editaddress');
    },
  },
  watch: {
    model: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit("input", value);       
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        this.model = value;
    
        this.modelToEdit = {
          physical: {
            addressTypeId: addressType.Physical,
            ...value.physical,
            address1: value.physical?.addressLine1,
            address2: value.physical?.addressLine2,
            zipCode: value.physical?.zipcode,
            isEdit: false,
            showError: false
          },
          postal: {
            addressTypeId: addressType.Postal,
            ...value.postal,
            address1: value.postal?.addressLine1,
            address2: value.postal?.addressLine2,
            zipCode: value.postal?.zipcode,
            isEdit: false,
            showError: false
          },
          postalInitial: {
            addressTypeId: addressType.Postal,
            ...value.postal,
            address1: value.postal?.addressLine1,
            address2: value.postal?.addressLine2,
            zipCode: value.postal?.zipcode,
            isEdit: false,
            showError: false
          }    

        };      
        
        if (
          value.postal?.addressLine1 !== null &&
          this.initialPostalValue === undefined
        ) {
          this.initialPostalValue = { ...value.postal };
        }
      }
    },
    "model.physical": {
      deep: true,
      handler(value) {
        if (this.hasPostalSamePropsThanPhysical)
          this.setValuesFromPhysical(true);
      }
    }
  },
  props: {
    value: {
      type: Object,
      default: () => ({      
        physical: {
          addressLine1: null,
          addressLine2: null,
          municipality: null, 
          zipcode: null
        },
        postal: {
          addressLine1: null,
          addressLine2: null,
          municipality: null,
          zipcode: null
        }
      })
    },    
    registrationId: {
      type: Number,
      default: null
    },
    municipalities: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      model: {
        physical: {
          addressLine1: null,
          addressLine2: null,
          municipality: null,
          zipcode: null       
        },
        postal: {
          addressLine1: null,
          addressLine2: null,
          municipality: null,
          zipcode: null        
        }
      },
      modelToEdit: {},
      initialPostalValue: undefined,
      sameAsPhysical: undefined,
      enableCopyFisicalAddress: false,
    };
  },
  methods: {
    showPhysicalEditAddress() {      
      this.modelToEdit.physical.showError = false;
      this.modelToEdit.physical.isEdit = true;
    },
    showPostalEditAddress() {
      this.modelToEdit.postal.showError = false;
      this.modelToEdit.postal.isEdit = true;
    },
    cancelPhysicalAddress() {    
      this.modelToEdit.physical.showError = false;
      this.modelToEdit.physical.isEdit = false;
    },
    cancelPostalAddress() {     
      this.modelToEdit.postal.showError = false;
      this.modelToEdit.postal.isEdit = false;
    },
    onChangePhysicalAddress() {
      const value = this.enableCopyFisicalAddress
        ? { ...this.modelToEdit.physical }
        : { ...this.modelToEdit.postalInitial };
      this.modelToEdit.postal.address1 = value.address1;
      this.modelToEdit.postal.address2 = value.address2;
      this.modelToEdit.postal.municipality = value.municipality;
      this.modelToEdit.postal.zipCode = value.zipCode;
    },
   copyFisicalAddress(value) {
      this.enableCopyFisicalAddress = value;
      this.onChangePhysicalAddress();
    },
    async saveAddressInformation(model, item) {
    
      try {       
        const payload = {
          id: this.registrationId,
          addressTypeId: item.addressTypeId,
          zipCode: model.zipCode,
          address1: model.address1,
          address2: model.address2,          
          municipalityId: model.municipality.id
        };

        await StudentServices.updateAddressInformation(payload);
        item.isEdit = false;
        this.ShowToast(
          "Proceso exitoso.",
          "La información ha sido actualizada exitosamente.",
          "success"
        );

        this.$emit('refresh')        
      } catch (error) {
        this.ShowToast(
          "",
          error.message || error.response.data.message,
          "error"
        );
      }
    },
    onInvalidAddress(name) {    
      this.ShowToast(
         "",
         `La información de la Dirección ${name} debe ser completada.`,
         "error"
      );
    },     
    formatAddress(value) {
      return `${value.addressLine1 ?? ""}${
        value.addressLine2 ? ", " + value.addressLine2 : ""
      }
      ${value.municipality ? ", " + value.municipality.name + ", PR" : ", "}
      ${this.formatZipcode(value.zipcode) ?? ""}`;
    },
    formatZipcode(zipcode) {
      if (!zipcode) return null;
      if (zipcode.length > 5 && !zipcode.includes("-", 5)) {
        return `${zipcode.substring(0, 5)}-${zipcode.substring(5)}`;
      }
      return zipcode;
    },
    setValuesFromPhysical(value) {
      this.$refs.postalForm.reset();
      if (value) {
        if (
          !(
            this.model.physical.addressLine1 &&
            this.model.physical.municipality &&
            this.model.physical.zipcode
          )
        ) {
          this.ShowToast(
            "",
            "La información de la dirección física debe ser completada.",
            "error"
          );
        } else {
          this.model.postal.addressLine1 = this.model.physical.addressLine1;
          this.model.postal.addressLine2 = this.model.physical.addressLine2;
          this.model.postal.municipality = this.model.physical.municipality;
          this.model.postal.zipcode = this.model.physical.zipcode;
        }
      } else {
        if (!!this.initialPostalValue) {
          this.model.postal.addressLine1 = this.initialPostalValue.addressLine1;
          this.model.postal.addressLine2 = this.initialPostalValue.addressLine2;
          this.model.postal.municipality = this.initialPostalValue.municipality;
          this.model.postal.zipcode = this.initialPostalValue.zipcode;
        } else {
          this.model.postal.addressLine1 = null;
          this.model.postal.addressLine2 = null;
          this.model.postal.municipality = null;
          this.model.postal.zipcode = null;
        }
      }
    },
    hasSameProps(obj1, obj2) {
      if (obj1 === undefined || obj1 === null) return false;
      if (obj2 === undefined || obj2 === null) return false;

      return !Object.entries(obj1).some(([key, valueObj1]) => {
        const valueObj2 = obj2[key];
        if (typeof valueObj1 === "object" && typeof valueObj2 === "object")
          return !this.hasSameProps(valueObj1, valueObj2);
        return valueObj1 !== valueObj2;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

.divider-horizontal {
  border: 0.5px solid map.get($colors, "gray-5");
  position: relative;
}

.phone-icon {
  display: inline-block;
  font-size: 18px;
  line-height: 32px;
  background-color: map.get($colors, "orange");
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  text-align: center;
  vertical-align: bottom;
}

.btn-action-size {
  width: 35px;
  height: 35px;
}
</style>
